<template>
  <v-icon dense style="vertical-align: top"
          @click="showInfo"
  >
    icon-information
  </v-icon>
</template>

<script>
    export default {
        name: "fin-info-icon",
        props:{
            alertTexts: {
                type: Object
            }
        },
        methods: {
            showInfo () {
                this.$alert(this.alertTexts)
            }
        }
    }
</script>

<style scoped>

</style>
